import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  it: {
    nav_operations: "Operazioni",
    nav_approach: "Approccio",
    nav_numbers: "Numeri",
    nav_contact: "Contatti",
    nav_admin: "Area Riservata",
    seo_home_title: "Investimenti Immobiliari a Milano — Capital Stone S.r.l.",
    seo_home_desc:
      "Capital Stone S.r.l. acquisisce, sviluppa e valorizza immobili di pregio a Milano. Scopri le operazioni immobiliari in corso, i progetti completati e proponi la tua operazione.",
    seo_op_desc: "Operazione immobiliare Capital Stone a {location}: {type}, {mq} mq, stato {status}. Foto, confronto prima/dopo, planimetrie e dossier PDF.",
    seo_priv_title: "Privacy & Cookie Policy — Capital Stone S.r.l.",
    seo_priv_desc: "Informativa sul trattamento dei dati personali e sull'uso dei cookie del sito Capital Stone S.r.l., società di investimenti immobiliari con sede a Milano.",
    hero_line1: "Trasformiamo visioni",
    hero_line2: "immobiliari in",
    hero_line3: "asset d'élite.",
    hero_sub:
      "Operazioni e investimenti ad alto valore strategico nel mercato immobiliare italiano. Acquisiamo, sviluppiamo e valorizziamo asset d'eccellenza.",
    hero_cta1: "Esplora le Operazioni",
    hero_cta2: "Proponi un'Operazione",
    hero_scroll: "Scorri",
    marquee: [
      "Acquisizioni Tattiche",
      "Sviluppo Immobiliare",
      "Riqualificazione Urbana",
      "Flipping & Frazionamenti",
      "Valorizzazione Patrimoniale",
      "Milano & Lago di Como",
    ],
    man_overline: "Manifesto",
    man_h1: "Il capitale incontra",
    man_h2: "la pietra.",
    man_ch1_t: "Chi Siamo",
    man_ch1_x:
      "Capital Stone S.r.l. è una società di investimento immobiliare con sede a Milano. Uniamo competenza tecnica, disciplina finanziaria e profonda conoscenza del territorio per generare valore duraturo da ogni operazione.",
    man_ch2_t: "Il Nostro Approccio",
    man_ch2_x:
      "Origination selettiva, due diligence rigorosa, execution impeccabile. Ogni asset viene acquisito con una tesi di valorizzazione chiara e un'exit strategica definita fin dal primo giorno.",
    man_ch3: "03 — I Nostri Numeri",
    stats: ["Operazioni vendute in un anno", "Operazioni concluse", "ROI medio realizzato", "Storicità del gruppo dal"],
    port_overline: "Portfolio",
    port_h1: "Le nostre",
    port_h2: "operazioni.",
    filters: ["Tutte", "Concluse", "In Corso", "In Arrivo"],
    card_value: "Valore",
    card_roi: "ROI",
    card_area: "Superficie",
    port_empty: "Nessuna operazione in questa categoria.",
    ba_overline: "Trasformazione",
    ba_h1: "Prima",
    ba_h2: "e dopo.",
    ba_hint: "Trascina la barra dorata sull'immagine per vedere la trasformazione dei nostri interventi.",
    ba_before: "Prima",
    ba_after: "Dopo",
    ct_overline: "Contatti",
    ct_h1: "Parliamo del tuo",
    ct_h2: "prossimo investimento.",
    ct_text:
      "Che tu sia un investitore, un proprietario o un operatore del settore, siamo pronti a valutare insieme la tua proposta con riservatezza e rapidità.",
    ct_name: "Nome e Cognome *",
    ct_email: "Email *",
    ct_phone: "Telefono",
    ct_types: ["Investitore", "Proposta Immobile", "Partnership", "Altro"],
    ct_message: "Il tuo messaggio *",
    ct_submit: "Invia richiesta",
    ct_sending: "Invio in corso...",
    ct_success: "Richiesta ricevuta. Il nostro team ti ricontatterà entro 24 ore lavorative.",
    ct_toast_ok: "Richiesta inviata con successo. Ti ricontatteremo a breve.",
    ft_top: "Torna su",
    ft_rights: "Tutti i diritti riservati",
    op_back: "Tutte le operazioni",
    op_value: "Valore",
    op_roi: "ROI",
    op_area: "Superficie",
    op_status: "Stato",
    op_timeline: "Timeline dei lavori",
    op_gallery: "Galleria",
    op_floorplans: "Planimetrie",
    op_inquire: "Richiedi informazioni",
    op_cta_t: "Interessato a questa operazione?",
    op_cta_x: "Contattaci per ricevere il dossier completo e valutare le opportunità di co-investimento.",
    op_notfound: "Operazione non trovata",
    op_dossier: "Scarica il dossier PDF",
    op_videos: "Video dal cantiere",
    op_listing: "Vedi l'annuncio",
    vid_overline: "Dietro le quinte",
    vid_h1: "Guarda come",
    vid_h2: "lavoriamo.",
    cookie_text:
      "Usiamo cookie tecnici necessari al funzionamento e, solo con il tuo consenso, cookie di marketing e statistica di terze parti (Meta, Google) per misurare le nostre campagne. Puoi cambiare scelta in qualsiasi momento da \"Gestisci cookie\" nel footer.",
    cookie_link: "Privacy & Cookie Policy",
    cookie_accept: "Accetta tutti",
    cookie_reject: "Solo necessari",
    cookie_customize: "Personalizza",
    cookie_save: "Salva preferenze",
    cookie_necessary: "Necessari",
    cookie_necessary_x: "Preferenza lingua e memorizzazione di questa scelta. Sempre attivi.",
    cookie_always: "Sempre attivi",
    cookie_marketing: "Marketing e statistica",
    cookie_marketing_x: "Meta Pixel e Google Tag per misurare le campagne pubblicitarie e mostrarti annunci pertinenti.",
    ft_cookies: "Gestisci cookie",
    priv_title: "Privacy & Cookie Policy",
    priv_updated: "Ultimo aggiornamento: ottobre 2026",
    priv_back: "Torna alla home",
    priv_sections: [
      {
        h: "Titolare del trattamento",
        b: "Capital Stone S.r.l. — Piazza Quattro Novembre 4, 20124 Milano (MI)\nP.IVA e C.F. 14417030963 · REA MI-2781885 · Capitale sociale € 30.000,00\nEmail: capitalstone.milano@gmail.com · PEC: capitalstone@pec.capitalstone.it · Tel: +39 333 116 0150",
      },
      {
        h: "Dati che raccogliamo",
        b: "Tramite il modulo contatti raccogliamo: nome e cognome, indirizzo email, numero di telefono (facoltativo), tipo di richiesta e contenuto del messaggio.\nTramite il modulo \"Prenota una visita\" delle pagine dedicate ai singoli immobili raccogliamo: nome e cognome, telefono, email, periodo preferito per la visita, eventuali note, data e ora del consenso, oltre a dati tecnici della richiesta (parametri della campagna pubblicitaria di provenienza come utm/gclid/fbclid, pagina di provenienza e tipo di browser).\nSolo con il tuo consenso, tramite i cookie di marketing e statistica descritti più avanti, raccogliamo dati di navigazione per misurare le nostre campagne pubblicitarie.",
      },
      {
        h: "Finalità e base giuridica",
        b: "I dati forniti tramite i moduli sono trattati per rispondere alle tue richieste di informazioni, organizzare visite e valutare proposte immobiliari (art. 6, par. 1, lett. b del GDPR — misure precontrattuali) e per adempiere a eventuali obblighi di legge.\nI dati raccolti tramite cookie di marketing e statistica sono trattati per misurare l'efficacia delle campagne pubblicitarie e mostrare annunci pertinenti, esclusivamente sulla base del tuo consenso (art. 6, par. 1, lett. a del GDPR), revocabile in qualsiasi momento.",
      },
      {
        h: "Conservazione dei dati",
        b: "Le richieste di contatto sono conservate per un massimo di 24 mesi, salvo instaurazione di un rapporto contrattuale. Decorso tale termine i dati vengono cancellati.",
      },
      {
        h: "Comunicazione a terzi",
        b: "I dati non sono venduti né ceduti a terzi. Possono essere trattati da fornitori tecnici (hosting, servizio email) che operano nel rispetto del GDPR in qualità di responsabili del trattamento.\nSolo se hai prestato il consenso ai cookie di marketing, i dati di navigazione sono comunicati a Meta Platforms Ireland Ltd (Meta Pixel) e Google Ireland Ltd (Google Tag / Google Ads / Google Analytics), che li trattano come titolari autonomi secondo le rispettive informative. Tali soggetti possono trasferire dati verso gli Stati Uniti sulla base del Data Privacy Framework UE-USA e di clausole contrattuali standard.",
      },
      {
        h: "Cookie e archiviazione locale",
        b: "Cookie tecnici e archiviazione locale (sempre attivi, non richiedono consenso): ricordano la preferenza di lingua e la tua scelta sul banner cookie.\nCookie di marketing e statistica (solo con il tuo consenso, selezionando \"Accetta tutti\" o attivandoli in \"Personalizza\"):\n• Meta Pixel — Meta Platforms Ireland Ltd: cookie _fbp e _fbc (durata fino a 90 giorni), per misurare le campagne su Facebook/Instagram e mostrare annunci pertinenti. Informativa: facebook.com/privacy/policy\n• Google Tag (Google Ads / Google Analytics) — Google Ireland Ltd: cookie _ga, _gid, _gcl_au e simili (durata da 24 ore a 2 anni), per misurare conversioni e traffico. Informativa: policies.google.com/privacy\nFinché non presti il consenso, nessuno di questi strumenti viene caricato. Puoi modificare o revocare il consenso in qualsiasi momento tramite \"Gestisci cookie\" nel footer del sito: alla revoca gli script vengono disattivati e i relativi cookie cancellati. Puoi inoltre eliminare i cookie dalle impostazioni del browser.",
      },
      {
        h: "I tuoi diritti",
        b: "Ai sensi degli artt. 15-22 del GDPR hai diritto di accesso, rettifica, cancellazione, limitazione, opposizione e portabilità dei tuoi dati.\nPer esercitarli scrivi a capitalstone.milano@gmail.com. Hai inoltre diritto di reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
      },
      {
        h: "Area riservata",
        b: "L'accesso all'area riservata è consentito ai soli amministratori della società. I tentativi di accesso sono registrati per finalità di sicurezza.",
      },
    ],
  },
  en: {
    nav_operations: "Operations",
    nav_approach: "Approach",
    nav_numbers: "Numbers",
    nav_contact: "Contact",
    nav_admin: "Client Area",
    seo_home_title: "Real Estate Investments in Milan — Capital Stone S.r.l.",
    seo_home_desc:
      "Capital Stone S.r.l. acquires, develops and enhances prime real estate in Milan. Discover ongoing operations, completed projects and propose your own deal.",
    seo_op_desc: "Capital Stone real estate operation in {location}: {type}, {mq} sqm, status {status}. Photos, before/after comparison, floor plans and PDF dossier.",
    seo_priv_title: "Privacy & Cookie Policy — Capital Stone S.r.l.",
    seo_priv_desc: "Information on personal data processing and cookie usage for the Capital Stone S.r.l. website, a real estate investment company based in Milan.",
    hero_line1: "We turn real estate",
    hero_line2: "visions into",
    hero_line3: "elite assets.",
    hero_sub:
      "High-value strategic real estate operations and investments in the Italian market. We acquire, develop and enhance assets of excellence.",
    hero_cta1: "Explore Operations",
    hero_cta2: "Propose a Deal",
    hero_scroll: "Scroll",
    marquee: [
      "Tactical Acquisitions",
      "Real Estate Development",
      "Urban Regeneration",
      "Flipping & Subdivisions",
      "Asset Enhancement",
      "Milan & Lake Como",
    ],
    man_overline: "Manifesto",
    man_h1: "Where capital",
    man_h2: "meets stone.",
    man_ch1_t: "Who We Are",
    man_ch1_x:
      "Capital Stone S.r.l. is a real estate investment company based in Milan. We combine technical expertise, financial discipline and deep local knowledge to generate lasting value from every deal.",
    man_ch2_t: "Our Approach",
    man_ch2_x:
      "Selective origination, rigorous due diligence, flawless execution. Every asset is acquired with a clear value-creation thesis and an exit strategy defined from day one.",
    man_ch3: "03 — Our Numbers",
    stats: ["Deals sold in one year", "Completed deals", "Average realized ROI", "Group track record since"],
    port_overline: "Portfolio",
    port_h1: "Our",
    port_h2: "operations.",
    filters: ["All", "Completed", "Ongoing", "Upcoming"],
    card_value: "Value",
    card_roi: "ROI",
    card_area: "Area",
    port_empty: "No operations in this category.",
    ba_overline: "Transformation",
    ba_h1: "Before",
    ba_h2: "and after.",
    ba_hint: "Drag the golden bar across the image to see the transformation of our projects.",
    ba_before: "Before",
    ba_after: "After",
    ct_overline: "Contact",
    ct_h1: "Let's discuss your",
    ct_h2: "next investment.",
    ct_text:
      "Whether you are an investor, a property owner or an industry operator, we are ready to review your proposal with confidentiality and speed.",
    ct_name: "Full name *",
    ct_email: "Email *",
    ct_phone: "Phone",
    ct_types: ["Investor", "Property Proposal", "Partnership", "Other"],
    ct_message: "Your message *",
    ct_submit: "Send inquiry",
    ct_sending: "Sending...",
    ct_success: "Inquiry received. Our team will get back to you within 24 business hours.",
    ct_toast_ok: "Inquiry sent successfully. We will contact you shortly.",
    ft_top: "Back to top",
    ft_rights: "All rights reserved",
    op_back: "All operations",
    op_value: "Value",
    op_roi: "ROI",
    op_area: "Area",
    op_status: "Status",
    op_timeline: "Works timeline",
    op_gallery: "Gallery",
    op_floorplans: "Floor plans",
    op_inquire: "Request information",
    op_cta_t: "Interested in this deal?",
    op_cta_x: "Contact us to receive the full dossier and evaluate co-investment opportunities.",
    op_notfound: "Operation not found",
    op_dossier: "Download PDF dossier",
    op_videos: "Site videos",
    op_listing: "View listing",
    vid_overline: "Behind the scenes",
    vid_h1: "See how we",
    vid_h2: "work.",
    cookie_text:
      "We use technical cookies required for the site to work and, only with your consent, third-party marketing and analytics cookies (Meta, Google) to measure our campaigns. You can change your choice at any time via \"Cookie settings\" in the footer.",
    cookie_link: "Privacy & Cookie Policy",
    cookie_accept: "Accept all",
    cookie_reject: "Necessary only",
    cookie_customize: "Customise",
    cookie_save: "Save preferences",
    cookie_necessary: "Necessary",
    cookie_necessary_x: "Language preference and storage of this choice. Always active.",
    cookie_always: "Always active",
    cookie_marketing: "Marketing & analytics",
    cookie_marketing_x: "Meta Pixel and Google Tag to measure advertising campaigns and show you relevant ads.",
    ft_cookies: "Cookie settings",
    priv_title: "Privacy & Cookie Policy",
    priv_updated: "Last updated: October 2026",
    priv_back: "Back to home",
    priv_sections: [
      {
        h: "Data Controller",
        b: "Capital Stone S.r.l. — Piazza Quattro Novembre 4, 20124 Milan (MI), Italy\nVAT / Tax ID 14417030963 · REA MI-2781885 · Share capital € 30,000.00\nEmail: capitalstone.milano@gmail.com · Certified email (PEC): capitalstone@pec.capitalstone.it · Tel: +39 333 116 0150",
      },
      {
        h: "Data we collect",
        b: "Through the contact form we collect: full name, email address, phone number (optional), request type and message content.\nThrough the \"Book a visit\" form on individual property pages we collect: full name, phone, email, preferred visit period, optional notes, date and time of consent, plus technical request data (advertising campaign parameters such as utm/gclid/fbclid, referring page and browser type).\nOnly with your consent, through the marketing and analytics cookies described below, we collect browsing data to measure our advertising campaigns.",
      },
      {
        h: "Purpose and legal basis",
        b: "Data provided through the forms is processed to respond to your inquiries, arrange visits and evaluate real estate proposals (Art. 6(1)(b) GDPR — pre-contractual measures) and to comply with legal obligations.\nData collected through marketing and analytics cookies is processed to measure the effectiveness of advertising campaigns and show relevant ads, exclusively on the basis of your consent (Art. 6(1)(a) GDPR), which can be withdrawn at any time.",
      },
      {
        h: "Data retention",
        b: "Contact inquiries are stored for a maximum of 24 months, unless a contractual relationship is established. After that period the data is deleted.",
      },
      {
        h: "Sharing with third parties",
        b: "Your data is never sold or disclosed to third parties. It may be processed by technical providers (hosting, email service) acting as data processors under the GDPR.\nOnly if you have consented to marketing cookies, browsing data is shared with Meta Platforms Ireland Ltd (Meta Pixel) and Google Ireland Ltd (Google Tag / Google Ads / Google Analytics), which process it as independent controllers under their own privacy policies. These parties may transfer data to the United States on the basis of the EU-US Data Privacy Framework and standard contractual clauses.",
      },
      {
        h: "Cookies and local storage",
        b: "Technical cookies and local storage (always active, no consent required): remember your language preference and your choice on the cookie banner.\nMarketing and analytics cookies (only with your consent, by selecting \"Accept all\" or enabling them under \"Customise\"):\n• Meta Pixel — Meta Platforms Ireland Ltd: _fbp and _fbc cookies (up to 90 days), to measure Facebook/Instagram campaigns and show relevant ads. Policy: facebook.com/privacy/policy\n• Google Tag (Google Ads / Google Analytics) — Google Ireland Ltd: _ga, _gid, _gcl_au and similar cookies (from 24 hours to 2 years), to measure conversions and traffic. Policy: policies.google.com/privacy\nUntil you give consent, none of these tools is loaded. You can change or withdraw your consent at any time via \"Cookie settings\" in the site footer: upon withdrawal the scripts are disabled and the related cookies deleted. You can also delete cookies from your browser settings.",
      },
      {
        h: "Your rights",
        b: "Under Articles 15-22 GDPR you have the right of access, rectification, erasure, restriction, objection and data portability.\nTo exercise them, write to capitalstone.milano@gmail.com. You also have the right to lodge a complaint with the Italian Data Protection Authority (www.garanteprivacy.it).",
      },
      {
        h: "Restricted area",
        b: "Access to the restricted area is limited to company administrators. Login attempts are logged for security purposes.",
      },
    ],
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("cs_lang") || "it");

  useEffect(() => {
    localStorage.setItem("cs_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => dict[lang][key] ?? dict.it[key] ?? key;

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
